export enum PermissionEnum {
  'PEOPLE_VIEW_MENU' = 0,
  'PEOPLE_CREATE' = 1,
  'PEOPLE_EDIT' = 2,
  'PEOPLE_VIEW' = 3,
  'PEOPLE_VIEW_PII' = 4,
  'PEOPLE_RESTORE' = 5,
  'PEOPLE_DELETE' = 6,
  'PEOPLE_ACTIVE_AND_INACTIVE' = 7,
  'PEOPLE_CAN_CREATE_USER' = 8,

  'CORE_VIEW_MENU' = 9,
  'CORE_CREATE' = 10,
  'CORE_EDIT' = 11,
  'CORE_VIEW' = 12,
  'CORE_VIEW_PII' = 13,
  'CORE_RESTORE' = 14,
  'CORE_DELETE' = 15,

  'PARTNER_VIEW_MENU' = 16,
  'PARTNER_CREATE' = 17,
  'PARTNER_EDIT' = 18,
  'PARTNER_VIEW' = 19,
  'PARTNER_VIEW_PII' = 20,
  'PARTNER_RESTORE' = 21,
  'PARTNER_DELETE' = 22,

  'PROFILE_VIEW_MENU' = 23,
  'PROFILE_CREATE' = 24,
  'PROFILE_EDIT' = 25,
  'PROFILE_VIEW' = 26,
  'PROFILE_VIEW_PII' = 27,
  'PROFILE_ACTIVATE' = 28,
  'PROFILE_DEACTIVATE' = 29,

  'STUDENT_VIEW_MENU' = 30,
  'STUDENT_CREATE' = 31,
  'STUDENT_EDIT' = 32,
  'STUDENT_VIEW' = 33,
  'STUDENT_VIEW_PII' = 34,
  'STUDENT_RESTORE' = 35,
  'STUDENT_DELETE' = 36,

  'CLASS_VIEW_MENU' = 37,
  'CLASS_CREATE' = 38,
  'CLASS_EDIT' = 39,
  'CLASS_VIEW' = 40,
  'CLASS_VIEW_PII' = 41,
  'CLASS_RESTORE' = 42,
  'CLASS_DELETE' = 43,

  'FREQUENCY_VIEW_MENU' = 44,
  'FREQUENCY_CREATE' = 45,
  'FREQUENCY_EDIT' = 46,
  'FREQUENCY_VIEW' = 47,
  'FREQUENCY_VIEW_PII' = 48,
  'FREQUENCY_RESTORE' = 49,
  'FREQUENCY_DELETE' = 50,

  'REPORT_VIEW_MENU' = 51,
  'REPORT_VIEW' = 52,
  'REPORT_VIEW_PII' = 53,

  'REPORT_SUPERVISOR_VIEW_MENU' = 54,
  'REPORT_SUPERVISOR_CREATE' = 55,
  'REPORT_SUPERVISOR_EDIT' = 56,
  'REPORT_SUPERVISOR_VIEW' = 57,
  'REPORT_SUPERVISOR_VIEW_PII' = 58,
  'REPORT_SUPERVISOR_RESTORE' = 59,
  'REPORT_SUPERVISOR_DELETE' = 60,
  'REPORT_SUPERVISOR_GENERATE_PDF' = 61,

  'DASHBOARD_VIEW_MENU' = 69,
  'DASHBOARD_OVERVIEW_VIEW' = 70,
  'DASHBOARD_FREQUENCY_VIEW' = 71,

  'PROJECT_CREATE' = 72,
  'PROJECT_VIEW' = 73,
  'PROJECT_VIEW_MENU' = 74,
}
